module.exports = __webpack_public_path__ + "img/logo-has-text.db7ed51f.gif";